import React from 'react';
import Button from 'shared/components/button/Button';

export default function ClientHeader(props) {
  return (
    <section className="client-header">
      <h3>{props.label}</h3>
      <Button color="primary" label="Add" onClick={props.toggle} />
    </section>
  );
}
